import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormDataDropDown from "../../components/formdatadropdown";
import FormDataAddItemPanel from "../../components/formdataadditempanel";
import {ToastContainer, ToastStore} from 'react-toasts';
import _ from "underscore";
import UsersService from "../../services/users-service";
import FormdataService from "../../services/formdata-service";
import GoogleMapReact from 'google-map-react';
import Geocode from "react-geocode";

import $ from "jquery";
import './style.css';
import moment from 'moment';

var onChangeTimeOut;
var stateNames = {"Client": "clients",
                  "Branch": "branches",
                  "Facility": "facilities",
                  "Facility Location": "facilityLocations",
                  "Event": "events",
                  "Call Type": "callTypes",
                  "Incident Type": "incidentTypes",
                  "Skill": "skills",
                  "Auto Email": "autoEmails",
                  "Custom Field 1": "customField1",
                  "Custom Field 2": "customField2",
                  "Custom Field 3": "customField3",
                  "Custom Field 4": "customField4",
                  "Custom Field 5": "customField5"}
  var prevProps = null;

class FormData extends Component {


  constructor(props, context) {
      super(props, context);

      this.onClickDropDown = this.onClickDropDown.bind(this);
      this.onChangeNewItemField = this.onChangeNewItemField.bind(this);
      this.onChangeExistingItemField = this.onChangeExistingItemField.bind(this);
      this.onAddItem = this.onAddItem.bind(this);
      this.deleteDropDown = this.deleteDropDown.bind(this);
      this.showDeleteDropDownModal = this.showDeleteDropDownModal.bind(this);
      this.getFormDataByType = this.getFormDataByType.bind(this);
      this.saveFormData = this.saveFormData.bind(this);
      this.updateData = this.updateData.bind(this);
      this.setTableFilter = this.setTableFilter.bind(this);
      this.filterByActive = this.filterByActive.bind(this);

      const storedCredenials = UsersService.sharedInstance.getStoredCredentials();

      this.state = {
        storedCredenials: storedCredenials,
        rawDropDowns: [
          {name: "Client",
           type: "basic",//basic, autoEmail, event. These will be assigned on a different function somewhere.
           items: [],
           lastUpdate: "Never",
          },
          {name: "Branch",
           type: "basic",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Facility",
           type: "basic",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Facility Location",
           type: "basic",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Event",
           type: "event",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Call Type",
           type: "basic",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Incident Type",
           type: "basic",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Skill",
           type: "basic",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Auto Email",
           type: "autoEmail",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Custom Field 1",
           type: "custom",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Custom Field 2",
           type: "custom",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Custom Field 3",
           type: "custom",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Custom Field 4",
           type: "custom",
           items: [],
           lastUpdate: "Never"
          },
          {name: "Custom Field 5",
           type: "custom",
           items: [],
           lastUpdate: "Never"
          },
        ],//For update purposes
        dropDowns: [
          {name: "Client",
           type: "basic",//basic, autoEmail, event. These will be assigned on a different function somewhere.
           keys: ["Client", "Sort Order", "Active"],//template for CSV
           items: [{name: "Shiva Industries", sortOrder: 1, isActive: true}],
           lastUpdate: "Never",
          },
          {name: "Branch",
           type: "basic",
           keys: ["Branch", "Sort Order", "Active"],
           items: [{name: "Branch X", sortOrder: 1, isActive: true},
                    {name: "Leganes", sortOrder: 2, isActive: true}],
           lastUpdate: "Never"
          },
          {name: "Facility",
           type: "basic",
           //keys: ["Branch","Facility", "Address","Sort Order", "Active"],
           keys: ["Facility", "Address", "Branch", "Client" , "Sort Order", "Active"],

           items: [{name: "Brian's Bar", branch: "Branch X", sortOrder: 1, isActive: false}],
           lastUpdate: "Never"
          },
          {name: "Facility Location",
           type: "basic",
           keys: ["Facility","Facility Location","Sort Order", "Active"],
           items: [],
           lastUpdate: "Never"
          },
          {name: "Event",
           type: "event",
           keys: ["Facility", "Date", "Event", "Sort Order"],
           items: [{name: "Joshua's Jam-eating Jamboree", facility: "Brian's Bar", date: "Jan 30, 2019 3:00PM", sortOrder: 1, isReoccurring: false},
                    {name: "Ena's Egg-peeling Excercises", facility: "Brian's Bar", date: "Jan 30, 2019 3:00PM", sortOrder: 2, isReoccurring: true, frequency: "monthly", frequencyNumber: 2}],
           lastUpdate: "Never"
          },
          {name: "Call Type",
           type: "basic",
           keys: ["Call Type", "Sort Order", "Active"],
           items: [],
           lastUpdate: "Never"
          },
          {name: "Incident Type",
           type: "basic",
            keys: ["Incident Type", "Sort Order", "Active"],
           items: [],
           lastUpdate: "Never"
          },
          {name: "Skill",
           type: "basic",
           keys: ["Skill", "Sort Order", "Active"],
           items: [],
           lastUpdate: "Never"
          },
          {name: "Auto Email",
           type: "autoEmail",
           keys: ["Form", "Branch", "Auto Email"],
           items: [{name: "Daily Activity Report", branch: "Branch X", facility: "Brian's Bar", autoEmail: "brodude@archontech.com", forceSend: false},
                    {name: "Motor Vehicle Collision", branch: "Branch X", facility: "Brian's Bar", autoEmail: "brodude@archontech.com", forceSend: false},
                    {name: "Employee Counseling", branch: "Branch X", facility: "Brian's Bar", autoEmail: "brodude@archontech.com", forceSend: true}],
           lastUpdate: "Never"
          },
          {name: "Custom Field 1",
           title: "",
           type: "custom",
           keys: ["Name", "Sort Order", "Active"],
           items: [{name: "Moon Phase", sortOrder: 1, isActive: true},
                    {name: "Run Phase", sortOrder: 2, isActive: false},
                    {name: "Glow Phase", sortOrder: 3, isActive: false}],
           lastUpdate: "Never"
          },
          {name: "Custom Field 2",
           title: "",
           type: "custom",
           keys: ["Name", "Sort Order", "Active"],
           items: [{name: "Weaver", sortOrder: 1, isActive: true},
                    {name: "Meepo", sortOrder: 2, isActive: true},
                    {name: "Magnus", sortOrder: 3, isActive: true}],
           lastUpdate: "Never"
          },
          {name: "Custom Field 3",
           title: "",
           type: "custom",
           keys: ["Name", "Sort Order", "Active"],
           items: [{name: "Random Value 1", sortOrder: 1, isActive: true},
                    {name: "Random Value 2", sortOrder: 1, isActive: true},
                    {name: "Random Value 3", sortOrder: 1, isActive: true}],
           lastUpdate: "Never"
          },
          {name: "Custom Field 4",
           title: "",
           type: "custom",
           keys: ["Name", "Sort Order", "Active"],
           items: [{name: "Random Value 1", sortOrder: 1, isActive: true},
                    {name: "Random Value 2", sortOrder: 1, isActive: true},
                    {name: "Random Value 3", sortOrder: 1, isActive: true}],
           lastUpdate: "Never"
          },
          {name: "Custom Field 5",
           title: "",
           type: "custom",
           keys: ["Name", "Sort Order", "Active"],
           items: [{name: "Random Value 1", sortOrder: 1, isActive: true},
                    {name: "Random Value 2", sortOrder: 1, isActive: true},
                    {name: "Random Value 3", sortOrder: 1, isActive: true}],
           lastUpdate: "Never"
          },
        ],//For Display purposes
        newDropDown: {},//Object to be pushed. Changes properties depending on onChange Function
        pressedDropDown: null,
        pressedDropDownType: "",
        showConfirmationModal: false,
        confirmationModalType: null,
        guiltyObject: {},//Generic object used for Confirmation Modals. Can be used for other stuff too. It's basically the "last clicked thing".
        tableFilter: {name: null, isActive:true},//Used for filtering. Loops through all the fields, and only returns items that returns true for all the keys
        sortByColumn: "sortOrder",
        sortByAscending: true,

      }

      this.deleteDropDownItem = this.deleteDropDownItem.bind(this);
  }

  render() {
    var pressedDropDown = this.state.pressedDropDown;
    return (<div >
                <div style={{fontSize: 25, color: "#F45F21", margin: 30}}> {"Manage Data for Your Dropdown"}</div>

                  <Row md={12} style={{marginLeft: 0, marginRight: 20}}>
                    <Col  md={4} >
                      <div style={{paddingTop: 15}}>
                         <ul>
                         {
                           this.state.dropDowns.map((dropDown, i)=>{
                             return <FormDataDropDown
                                      key={i}
                                      deleteDropDown={this.deleteDropDown}
                                      onClickDropDown={this.onClickDropDown}
                                      dropDown={dropDown}
                                      pressedDropDown={pressedDropDown}
                                      moveUpDropDown={this.moveUpDropDown}
                                      moveDownDropDown={this.moveDownDropDown}
                                      showDeleteDropDownModal={this.showDeleteDropDownModal}
                                      repackItems={this.repackItems}
                                      onAddItem={this.onAddItem}
                                      getRecnoForName={this.props.getRecnoForName}
                                      getIDForFormName={this.props.getIDForFormName}/>
                           })
                         }
                         </ul>
                     </div>
                    </Col>
                    <Col md={8}>

                      <div style={{}}>
                                <FormDataAddItemPanel
                                  dropDowns={this.state.dropDowns}
                                  onChangeNewItemField={this.onChangeNewItemField}
                                  newDropDown={this.state.newDropDown}
                                  pressedDropDown={this.state.pressedDropDown}
                                  dropDownType={this.state.pressedDropDownType}
                                  onAddItem={this.onAddItem}
                                  getNameForRecno={this.props.getNameForRecno}
                                  getRecnoForName={this.props.getRecnoForName}
                                  onChangeCustomName={this.onChangeCustomName}
                                  setTableFilter={this.setTableFilter}
                                  tableFilter={this.state.tableFilter}
                                  filterByActive={this.filterByActive}
                                  tableFilter={this.state.tableFilter}
                                />
                            {pressedDropDown
                                ? this.renderTable()
                                : null}

                      </div>

                    </Col>
                  </Row>
                    {this.renderConfirmationModal()}
                    {this.renderMapOverlay()}
                   <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
            </div>);
  }

  componentWillMount() {

  }

  componentDidMount() {
    this.props.setFormDataUpdateData(this.updateData);
    // this.state.dropDowns.map((dropDown, i)=>{
    //     this.getFormDataByType(dropDown, i);
    // })

    setTimeout(() => {
      this.getCustomTitles();
    },2000);

  }

  componentDidUpdate(prevProps, prevState) {
      if(JSON.stringify(this.prevProps) !== JSON.stringify(this.props)) {
        this.prevProps = prevProps;

        var newState = {};
        var newDropDowns = this.state.dropDowns.slice();


        this.state.dropDowns.map((dropDown, i)=>{
          var newDropDown = JSON.parse(JSON.stringify(dropDown));
          newDropDown.items = this.repackItems(this.props[stateNames[dropDown.name]], dropDown.name.replace(" ", "_"));
          newDropDowns[i] = newDropDown;
        })

        var newPressedDropDown = null;
        if(this.state.pressedDropDown) {
          newPressedDropDown = _.find(newDropDowns, (item)=>{
            return item.name === this.state.pressedDropDown.name
          });
        }

        this.setState({
          dropDowns: newDropDowns,
          pressedDropDown: newPressedDropDown,
        })
      } else {
        //console.log("prevProps.clients: ", prevProps.clients, " this.props: ", this.props.clients);
      }
  }

  componentWillUnmount() {
    this.prevProps = null;
  }

  getCustomTitles = () =>{
    const {dropDowns} = this.state;
    const customs = [];

    dropDowns.map(({name,type}) => {
      if(type === 'custom'){
        const key = name.replace(/ /g,'_').toLowerCase() + '_name';

        customs.push({
          key,
          name,
          type
        });
      }
    });

    customs.map(custom => this.getCustomReportName(custom))
  }

  getCustomReportName = ({key,name}) =>{
    const that = this;
    const {storedCredenials,dropDowns} = this.state;
    const {loginResponse} = storedCredenials;

    const {token_data} = loginResponse;
    const data = loginResponse.data[0];

    const license = data.User_License;
    const auth_username = data.User_ID;
    const {token} = token_data;

    const param = {
      token,
      license,
      auth_username,
      type:key
    }

    FormdataService.sharedInstance.getFormDataByType(param)
      .then(res => {
        if(res.length){
          const {Value} = res[0];

          const dropdowns = dropDowns.map(dropdown => {
            if(dropdown.name == name){
              dropdown.title = Value;
            }

            return dropdown;
          });

          that.setState({ dropDowns:dropdowns });
        }
      }).catch(err => {
        console.error('Error:',err);
        alert(err.message);
      });
  }

  onChangeCustomName = (value,dropdown) =>{
    const that = this;
    const {storedCredenials,dropDowns} = this.state;
    const {loginResponse} = storedCredenials;

    const {token_data} = loginResponse;
    const data = loginResponse.data[0];

    const license = data.User_License;
    const auth_username = data.User_ID;
    const {token} = token_data;

    const type = dropdown.name.replace(/ /g,'_').toLowerCase() + '_name';
    const param = {
      type,
      value,
      token,
      license,
      auth_username
    }

    FormdataService.sharedInstance.updateCustomName(param)
      .then(res => {
        console.log("updateCustomName",res);
        if(res.success){
          const dropdowns = dropDowns.map(dropDown => {
            if(dropdown.name == dropDown.name){
              dropDown.title = value;
            }

            return dropDown;
          });

          that.setState({ dropDowns:dropdowns });
        }else{
          alert(res.error);
        }
      }).catch(err => {
        console.error('Error:',err);
      });
  }

  renderTable() {
    var pressedDropDown = this.state.pressedDropDown;

    var items = this.filterItems(pressedDropDown.items, this.state.tableFilter);
        items = this.filterByActiveActual(items);
    return (<div><Table striped bordered hover>
                  <thead style={{fontSize: 14}}>
                      <tr >
                      {items.length > 0
                         ? Object.keys(items[0]).map(function(key, index) {

                             var keysToHide = ["frequency", "frequencyNumber", "id", "latitude", "longitude", "address"];
                             const title = pressedDropDown.title || null;
                             const name = pressedDropDown.name;

                             if(keysToHide.indexOf(key) < 0) {
                               if(key === "name") {

                                 var minWidth = key == "name" ? window.innerWidth * 0.15 : null;

                                 if(pressedDropDown.name == "Auto Email" ) {
                                   return (<th key={key+"_key"} style={{textAlign: "center", width: minWidth}}>{
                                                                   "Forms"
                                                                 }</th>);
                                 } else {
                                   switch(pressedDropDown.name) {
                                     case "Facility":
                                      return ([<th key={key+"_key"} style={{textAlign: "center", width: minWidth}}>
                                                  {pressedDropDown.name + " Name"}
                                              </th>, <th key={"location_key"} style={{textAlign: "center"}}>
                                                         Map
                                                   </th>]);
                                    case "Facility Location":
                                      return ([<th key={key+"_key"} style={{textAlign: "center", width: minWidth}}>
                                                 {pressedDropDown.name + " Name"}
                                             </th>, <th key={"location_key"} style={{textAlign: "center"}}>
                                                        Map
                                                  </th>]);
                                     default:
                                       return (<th key={key+"_key"} style={{textAlign: "center", width: minWidth}}>
                                                    {(title || name) + " Name"}
                                              </th>);
                                     break;
                                   }

                                 }


                               } else if(key === "frequencyNumber" || key === "frequency"){
                                 return null;
                               } else if(key === "sortOrder") {
                                 return <th key={key+"_key"} style={{textAlign: "center", maxWidth: window.innerWidth * 0.05}}>{key.charAt(0).toUpperCase() + key.slice(1)}</th>
                               } else if (key === "id") {
                                 return null
                               } else if(key !== "isActive" && key != "isReoccurring") {
                                 return <th key={key+"_key"} style={{textAlign: "center"}}>{key.charAt(0).toUpperCase() + key.slice(1)}</th>
                               }  else {
                                 return <th key={key+"_key"}></th>
                               }
                             }

                            })
                          : <th style={{textAlign: "center"}}>No Items</th>
                      }
                      </tr>
                  </thead>
                  {items.length > 0
                    ? <tbody style={{fontSize: 13}}>
                        { items.map((item, index)=>{
                              var columns = [];
                              var rows = [];
                              var isReoccurring = item.isReoccurring == "1" ? true : false;
                              var isReoccurringFields = null;
                              var fieldDetails = null;
                              var isValidTableItem = this.isValidTableItem(item);
                              var keysToHide = ["frequency", "frequencyNumber", "id", "latitude", "longitude", "address"];

                              //if(isValidTableItem) { //Wrong. rows here are merely for popup fields
                                Object.keys(item).map((key, keyIndex)=>{
                                  if(keysToHide.indexOf(key) < 0) {
                                    switch(key) {
                                      case "isActive":
                                        columns.push(<td key={item.name+ "_Checkbox_key_"+keyIndex} >
                                                          <Checkbox inline defaultChecked={item[key]} onClick={()=>{this.onChangeExistingItemField(item, "isActive", !item[key]);}}>Active </Checkbox>
                                                          {
                                                            //<Glyphicon glyph="trash" onClick={()=>{this.setState({showConfirmationModal: true, confirmationModalType: 'deleteDropDownItem', guiltyObject: {dropDown: pressedDropDown, dropDownItem: item}})}} style={{marginLeft: 15, cursor: "pointer"}}/>
                                                          }
                                                      </td>);
                                      break;
                                      case "isReoccurring":
                                        columns.push(<td key={item.name+ "_Checkbox_key_"+keyIndex}>
                                                          <Checkbox inline defaultChecked={item[key] == "1" ? true : false} onClick={()=>{this.onChangeExistingItemField(item, "isReoccurring", item[key] == "1" ? "0" : "1");}}>Reoccurring </Checkbox>
                                                          {
                                                            //<Glyphicon glyph="trash" onClick={()=>{this.setState({showConfirmationModal: true, confirmationModalType: 'deleteDropDownItem', guiltyObject: {dropDown: pressedDropDown, dropDownItem: item}})}} style={{marginLeft: 15, cursor: "pointer"}}/>
                                                          }
                                                    </td>);

                                      break;
                                      case "sortOrder":
                                        columns.push(<td key={item.name+ "_sortOrder_key_"+keyIndex} >
                                                        <input type="text" style={{textAlign: "center", maxWidth: window.innerWidth * 0.05}} value={item.sortOrder != null ? item.sortOrder : "None"} onChange={(e)=>{
                                                          this.onChangeExistingItemField(item, "sortOrder", e.target.value);
                                                        }}/>
                                                      </td>);
                                      break;
                                      default:
                                        fieldDetails = this.processFieldType(key, pressedDropDown);
                                        if(fieldDetails.type == 'dropdown') {
                                          columns.push(this.renderItemDropdowns(fieldDetails.data.items, true, key, item, this.state.pressedDropDown));
                                        } else if(fieldDetails.type == 'checkbox') {
                                          columns.push(<td key={item.name+ "_Checkbox_key_"+keyIndex} style={{textAlign: "center"}} >

                                                              <Checkbox
                                                                defaultChecked={item[key] == 0 ? false : true}
                                                                inline
                                                                style={{width: 25, paddingBottom: 20}}
                                                                onClick={()=>{this.onChangeExistingItemField(item, key, item[key] ? 0 : 1);}}></Checkbox>

                                                                {
                                                                 /* key == "forceSend"
                                                                  ? <OverlayTrigger
                                                                      placement="top"
                                                                      delay={200}
                                                                      overlay={<Tooltip id="overlay-example">
                                                                                        Delete this item
                                                                              </Tooltip>}>
                                                                      <Glyphicon glyph="trash"
                                                                      onClick={()=>{
                                                                                this.setState({
                                                                                  showConfirmationModal: true,
                                                                                  confirmationModalType: 'deleteDropDownItem',
                                                                                  guiltyObject: {
                                                                                    dropDown: pressedDropDown,
                                                                                    dropDownItem: item
                                                                                  }
                                                                                })
                                                                              }}
                                                                      style={{marginLeft: 15, cursor: "pointer", marginTop: "5%"}}/>

                                                                        </OverlayTrigger>
                                                                  : null*/
                                                                }

                                                      </td>);
                                        } else if(fieldDetails.type == 'textInput') {
                                          columns.push(<td key={pressedDropDown.name+"_" + index + "_" + key + "_input"}>
                                                          <input type="text" style={{textAlign: "center", maxWidth: 150}} value={item[key] ? item[key] : ""} onChange={(e)=>{
                                                            this.onChangeExistingItemField(item, key, e.target.value);
                                                          }}/>
                                                        </td>);
                                        } else {

                                          var cloneButton = pressedDropDown.name == "Auto Email" && key == "name"
                                                              ? <OverlayTrigger
                                                                  placement="top"
                                                                  delay={200}
                                                                  inline
                                                                  overlay={<Tooltip id="overlay-example">
                                                                                    Clone this item
                                                                                  </Tooltip>}>
                                                                  <Glyphicon glyph="paste"
                                                                            style={{marginLeft: 15, marginRight: 15, cursor: "pointer"}}
                                                                            onClick={()=>{
                                                                                this.onCloneTableItem(pressedDropDown, item, ["name", "branch", "facility", "autoEmail"])
                                                                            }} />
                                                                </OverlayTrigger>
                                                              : null;
                                          var textAlign = key == "name" ? "left" : "center";
                                          var toolTip =  <Tooltip id="overlay-example">
                                                            {key == "date" ? moment(new Date(item[key])).format("MM-DD-YYYY h:mm A"): item[key]}
                                                          </Tooltip>;

                                          var truncateWidth = key === "name" && pressedDropDown.name === "Auto Email" ? window.innerWidth * 0.13: null;

                                          columns.push(<td key={key+ "_" + index + "_key_"+keyIndex} style={{ textAlign: textAlign, alignItems: "left"}}>
                                                          {cloneButton}
                                                          <OverlayTrigger
                                                              placement="top"
                                                              delay={200}
                                                              overlay={toolTip}>
                                                                <Truncate lines={1}
                                                                          ellipsis={"..."}
                                                                          width={truncateWidth}>
                                                                          {key == "date" ? moment(new Date(item[key])).format("MM-DD-YYYY"): item[key]}
                                                                </Truncate>
                                                              </OverlayTrigger>
                                                        </td>);

                                          if(key === "name" && (pressedDropDown.name === "Facility" || pressedDropDown.name === "Facility Location")) {
                                            columns.push(<td key={key+ "_location_" + index + "_key_"+keyIndex}
                                                              style={{
                                                                      textAlign: textAlign, alignItems: "left",
                                                                      minWidth: pressedDropDown.name === "Facility"
                                                                                ? window.innerWidth * 0.08
                                                                                : null}}>
                                                            {item.address
                                                                        ? pressedDropDown.name === "Facility"
                                                                                ? item.address
                                                                                : "No Address"
                                                                        : null}
                                                            <OverlayTrigger
                                                                placement="top"
                                                                delay={200}
                                                                overlay={<Tooltip id="overlay-example">
                                                                                  Set a Map location
                                                                        </Tooltip>}>
                                                                  <Glyphicon glyph="map-marker"
                                                                               onClick={()=>{this.setState({guiltyObject: item, showMapOverlay: true})}}
                                                                               style={{marginLeft: 15, cursor: "pointer", color: "black"}}/>
                                                             </OverlayTrigger>
                                                         </td>);
                                          }
                                        }

                                      break;
                                    }

                                    if(key == "isReoccurring" && item[key]) {
                                      isReoccurringFields = <tr key={item.name+ "_recurringDetails"}>
                                                        <td colSpan={5}>
                                                          <div style={{marginBottom: 20}}>
                                                          <ButtonGroup justified >
                                                            <DropdownButton
                                                              title={item.frequency ? item.frequency : "Select Frequency"}
                                                              id={item.name+ "_eventFrequency"}
                                                              onSelect={(e)=>{
                                                                 this.onChangeExistingItemField(item, "frequency", e);
                                                              }}>
                                                                <MenuItem  style={{width: 600, textAlign: "center"}} key={"daily"} eventKey="daily">Daily</MenuItem>
                                                                <MenuItem  style={{width: 600, textAlign: "center"}} key={"monthly"} eventKey="monthly">Monthly</MenuItem>
                                                                <MenuItem  style={{width: 600, textAlign: "center"}} key={"yearly"} eventKey="yearly">Yearly</MenuItem>
                                                            </DropdownButton>
                                                          </ButtonGroup>
                                                          </div>


                                                          Every:
                                                          <input type="text" style={{width: "100%", textAlign: "center"}} value={item["frequencyNumber"]} onChange={(e)=>{
                                                            this.onChangeExistingItemField(item, "frequencyNumber", e.target.value)
                                                          }}/>
                                                        </td>
                                                    </tr>
                                    }
                                  }


                                });
                                rows.push(<tr key={pressedDropDown.name+"_"+index+"_key"}>
                                          {
                                            columns
                                          }
                                          </tr>);
                                if(isReoccurring) {
                                  rows.push(isReoccurringFields);
                                }

                              //}
                              return (rows);

                          })
                        }
                      </tbody>
                    : null
                  }

              </Table></div>);
  }

  renderConfirmationModal() {
    const {guiltyObject} = this.state;

    switch(this.state.confirmationModalType) {
      case 'deleteDropDown':
        return (<Modal style={{marginTop: "10%"}}
                        show={this.state.showConfirmationModal}
                        onExit={()=>{this.setState({showConfirmationModal: false, guiltyObject: null, confirmationModalType: null})}}>
                <Modal.Header>
                  <b style={{fontSize: 20}}>Confirm Deletion</b>
                </Modal.Header>
                <Modal.Body>
                  <div style={{textAlign: 'center'}}>Are you sure you want to delete "<b>{guiltyObject.dropDown.name}</b>"?</div>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={()=>{this.setState({showConfirmationModal: false})}}>Cancel</Button>
                  <Button bsStyle="danger" onClick={()=>{this.deleteDropDown(guiltyObject.dropDown)}}>Delete</Button>
                </Modal.Footer>
               </Modal>);
     case 'deleteDropDownItem':
       return (<Modal style={{marginTop: "10%"}}
                      show={this.state.showConfirmationModal}
                      onExit={()=>{this.setState({showConfirmationModal: false, guiltyObject: null, confirmationModalType: null})}}>
              <Modal.Header>
                <b style={{fontSize: 20}}>Confirm Deletion</b>
              </Modal.Header>
               <Modal.Body>
                 Are you sure you want to delete "<b>{guiltyObject.dropDownItem.name}</b>" from "<b>{guiltyObject.dropDown.name}</b>"? All options dependent on this will also be deleted.
               </Modal.Body>
               <Modal.Footer>
                 <Button onClick={()=>{this.setState({showConfirmationModal: false})}}>Cancel</Button>
                 <Button bsStyle="danger" onClick={()=>this.deleteDropDownItem(guiltyObject.dropDown,guiltyObject.dropDownItem)}>Delete</Button>
               </Modal.Footer>
              </Modal>);
     default:
       return (<Modal style={{marginTop: "10%"}}
                        show={this.state.showConfirmationModal}
                        onExit={()=>{this.setState({showConfirmationModal: false})}}>
                  <Modal.Header>
                    <b style={{fontSize: 20}}>Confirm Deletion</b>
                  </Modal.Header>
                   <Modal.Body>
                      Invalid Modal Type: "{this.state.confirmationModalType}"
                   </Modal.Body>
                   <Modal.Footer>
                     <Button onClick={()=>{this.setState({showConfirmationModal: false, guiltyObject: null, confirmationModalType: null})}}>Close</Button>
                   </Modal.Footer>
              </Modal>);
    }
  }

  onClickDropDown(dropDown) {
    var pressedDropDown = this.state.pressedDropDown;
    var newDropDown = {name:""};
    //console.log("this.props.raws: ", this.state.rawDropDowns);
    console.log("pressedDropDown: ", dropDown);
    this.setState({
      pressedDropDown: dropDown,
      newDropDown: newDropDown,
      pressedDropDownType: dropDown.name,
      tableFilter: {isActive:true},
    });
  }

  onChangeNewItemField(field, value) {
    var tempDropDown = this.state.newDropDown;
    if(field != null) {
      tempDropDown[field] = value;
      this.setState({
        newDropDown: tempDropDown
      })
    }
    //Add API call to update DB
  }

  onChangeExistingItemField(item, field, value) {
    var pressedDropDown = this.state.pressedDropDown;
    var dropDowns = this.state.dropDowns.slice();
    var dropDownIndex = dropDowns.indexOf(pressedDropDown);
    var itemIndex = pressedDropDown.items.indexOf(item);

    var newPressedDropDown = this.state.pressedDropDown;
    var newItem = JSON.parse(JSON.stringify(item));
    var newDropDowns = this.state.dropDowns.slice();
    var type = this.state.pressedDropDown.name;
    newItem[field] = value;
    var organizedNewItem = {};
    if(pressedDropDown.name == "Facility Location") {
      organizedNewItem = {facility: newItem.facility, name: newItem.name};
      Object.keys(newItem).forEach((key)=> {
        organizedNewItem[key] = newItem[key];
      });
    } else {
      organizedNewItem = {name: newItem.name};
      Object.keys(newItem).forEach((key)=> {
       organizedNewItem[key] = newItem[key];
      });
    }

    console.log("item: ", item);
    console.log("newItem: ", newItem);

    var newItemList = newPressedDropDown.items.slice();
    newItemList.splice(itemIndex, 1, organizedNewItem);
    // newItemList = _.sortBy(newItemList, (itemListItem)=>{
    //   return parseInt(itemListItem.sortOrder);
    // })

    newPressedDropDown.items = newItemList;
    newDropDowns.splice(dropDownIndex, 1, newPressedDropDown);
    this.setState({
      pressedDropDown: newPressedDropDown,
      dropDowns: newDropDowns,
      guiltyObject: organizedNewItem,
    });

    //Add focus() on involved field (if editing text)
    if(onChangeTimeOut != null) {
      clearTimeout(onChangeTimeOut);
    }

    onChangeTimeOut = setTimeout(()=>{
      console.log("Updating!!");
      var newNewItem =  JSON.parse(JSON.stringify(organizedNewItem))
      newNewItem["type"] = type;
      ///Replace newItem with item from state dropdowns , use indexOf
      this.updateFormData(newNewItem);
    }, 1500);

    //this.saveFormData(form_data);
    //newPressedDropDown.name
    //Add API call to update DB
  }

  onCloneTableItem(pressedDropDown, item, fieldsToClone) {

    var newItem = JSON.parse(JSON.stringify(item));
    //For some reason, newItem = item results to point by reference. Could've sworn it didn't work like that before - Tere
    Object.keys(newItem).map((key, index)=>{
      if(!fieldsToClone.includes(key)) {
        newItem[key] = null;
      }
    });
    this.setState({newDropDown: newItem});

    console.log("addItem: ", newItem);
      setTimeout(()=>{
          this.onAddItem();
      }, 500)

    //API Call here for adding stuff. On the then() of the call, find the dropDown
    //with same id or whatever as the pressedDropDown, then re-select pressedDropDown.
    //After repopulating the Dropdowns with the new list from the API, the dropdowns'
    //items will have been updated already, so don't do the next line anymore in the API call - tere
    // pressedDropDown.items.push(newItem);//The next line. Don't do this no more when the API is ready
    // this.setState({pressedDropDown: pressedDropDown});
  }

  onAddItem(csvItem) {

      var tempDropDown = JSON.parse(JSON.stringify(this.state.newDropDown));
      var tempPressedDropDown = JSON.parse(JSON.stringify(this.state.pressedDropDown));
      var tempdropDowns = this.state.dropDowns.slice();
      if(csvItem != null) {
        tempDropDown = csvItem;
      }

      if(this.isValidItemToAdd(tempDropDown, tempPressedDropDown.name)) {
        if(tempDropDown.name != "" && tempDropDown.name != null) {
          if(csvItem == null) {
            tempDropDown["sortOrder"] = tempPressedDropDown.items.length + 1;
          }

          if(tempPressedDropDown.name === "Auto Email") {
            tempDropDown["forceSend"] = true;
          }
          tempPressedDropDown.items.push(tempDropDown);

          var index = tempdropDowns.indexOf(tempPressedDropDown);
          tempdropDowns[index] = tempPressedDropDown;

          var form_data = {};

          form_data = {
                          type: tempPressedDropDown.name.toLowerCase(),
                          value: tempDropDown.name,
                          is_active: 1,
                          sort_order: parseInt(tempDropDown.sortOrder),
                        }
            if(tempPressedDropDown.name == "Facility") {
              form_data["branch"] = tempDropDown.branch;
              form_data["client"] = tempDropDown.client;
              form_data["address"] = tempDropDown.address;
              form_data["latitude"] = tempDropDown.latitude;
              form_data["longitude"] = tempDropDown.longitude;
            }

            if(tempPressedDropDown.name == "Facility Location") {
              form_data["facility"] = tempDropDown.facility;
              form_data["latitude"] = tempDropDown.latitude;
              form_data["longitude"] = tempDropDown.longitude;
            }

            if(tempPressedDropDown.name == "Branch") {
              //form_data["client"] = tempDropDown.client;
            }

            if(tempPressedDropDown.name == "Event") {
              form_data["facility"] = tempDropDown.facility;
              form_data["event_date"] = tempDropDown.date;
              form_data['isReoccurring'] = tempDropDown.isReoccurring ? 1 : 0;
              form_data['frequency'] = tempDropDown.frequency;
              form_data['frequencyNumber'] = tempDropDown.frequencyNumber;
            }

            if(tempPressedDropDown.name == "Auto Email") {
              form_data["branch"] = tempDropDown.branch;
              form_data["autoEmail"] = tempDropDown.autoEmail;
              form_data["facility"] = tempDropDown.facility ? tempDropDown.facility : "None";
              form_data["forceSend"] = tempDropDown.forceSend;
              form_data["form"] = this.getIDForFormName(tempDropDown.name);
            }
          this.saveFormData(form_data);
          //Add API call to update DB
          const dropDownTitle = tempPressedDropDown.title || null;
          const dropDownName = tempPressedDropDown.name;

          ToastStore.success(tempDropDown.name + " added to " + (dropDownTitle || dropDownName));
        } else {
          ToastStore.error("No name added to item!")
        }
    } else if (csvItem) {
      $("#csvReader_"+tempPressedDropDown.name.replace(' ', '_')).val("");
    }

  }

  renderExtraColumns(pressedDropDown, type, item) {
    var columns = [];
    switch(type) {
      case "basic":
      break;
      default:
      break;
    }

    return columns;
  }

  deleteDropDown(dropDown) {
    var dropDowns = this.state.dropDowns;

    dropDowns.splice(dropDowns.indexOf(dropDown), 1);
    this.setState({
      dropDowns: dropDowns,
      showConfirmationModal: false,
      pressedDropDown: null,
    });
      ToastStore.warning("Deleted \"" + dropDown.name + "\"!", 4000);
  }

  deleteDropDownItem = (dropDown, dropDownItem) =>{
    var newDropDowns = this.state.dropDowns.slice();

    var newDropDown = dropDown;
    var itemIndex = newDropDown.items.indexOf(dropDownItem);
    var dropDownIndex = newDropDowns.indexOf(dropDown);

    newDropDown.items.splice(itemIndex, 1);
    this.setState({
      showConfirmationModal: false,
    });
    const storedCredenials = this.state.storedCredenials;
    const loginResponse = storedCredenials.loginResponse;

    const form_data = {
      recno_id: this.props.getRecnoForName(dropDownItem.name, dropDown.name),
      type: dropDown.name.replace(' ', '_'),
      license: loginResponse.data[0].User_License,
      auth_username: loginResponse.data[0].User_ID,
      token: loginResponse.token_data.token,
    }

    if(dropDown.name === 'Auto Email' || dropDown.name === 'Facility Location'){
      form_data.recno_id = dropDownItem.id;
    }

    this.deleteFormData(form_data, dropDown, dropDownItem);

  }

  showDeleteDropDownModal(guiltyObject) {
    this.setState({
      showConfirmationModal: true,
      confirmationModalType: 'deleteDropDown',
      guiltyObject: guiltyObject,
    })
  }

  renderItemDropdowns(items, isExisting, field, rowObject, parentObject) {
    var title = rowObject[field];
    if((parentObject.name == "Auto Email" || parentObject.name == "Event") && !isNaN(rowObject[field])) {
      var recno = this.props.getNameForRecno(rowObject[field], field.charAt(0).toUpperCase() + field.slice(1));
      title = recno ? recno : rowObject[field] + " recno not found";
    }

    return (<td key={field + "_" + rowObject.name + "_" + parentObject.name.replace(' ', '_') + "_genericDropdown"}>
                  <ButtonGroup justified >
                    <DropdownButton
                      title={title ? title : "Select " + field}
                      id={rowObject.name+ "_" + parentObject.name + "_" + field}
                      style={{fontSize: 12, overflow: "hidden"}}
                      onSelect={(e)=>{
                        if(isExisting) {
                          this.onChangeExistingItemField(rowObject, field, e);
                        } else {
                          this.onChangeNewItemField(field, e);
                        }
                      }}>
                        {items.map((item, i)=>{
                            var eventKey = item.name;

                            // if(parentObject.name == "Auto Email") {
                            //     eventKey = this.props.getRecnoForName(item.name, field.charAt(0).toUpperCase() + field.slice(1));
                            // }
                            return (<MenuItem  style={{textAlign: "center", fontSize: 12}} key={item.name+"_"+i} eventKey={eventKey}>{item.name}</MenuItem>);
                        })}
                    </DropdownButton>
                  </ButtonGroup>
              </td>);
  }

  renderMapOverlay() {
    var name = this.state.guiltyObject ? this.state.guiltyObject.name : "None";
    var mapOptions = (maps) => {
      return {
                mapTypeControl: true,
                mapTypeId: maps.MapTypeId.SATELLITE,
              }
    }
    var longitude = this.state.guiltyObject && this.state.guiltyObject.longitude ? this.state.guiltyObject.longitude : 122.9563;
    var latitude = this.state.guiltyObject && this.state.guiltyObject.latitude ? this.state.guiltyObject.latitude : 10.6840;
    var center = {lat: parseFloat(latitude), lng: parseFloat(longitude)};
    var item = this.state.guiltyObject;
    return (<Modal style={{marginTop: "10%"}}
                    show={this.state.showMapOverlay}
                    onExit={()=>{this.setState({showMapOverlay: false, guiltyObject: null})}}>
            <Modal.Header>
              <b style={{fontSize: 20}}>{name}</b>
            </Modal.Header>
            <Modal.Body>
              <div style={{textAlign: 'center'}}>
                { this.state.pressedDropDown && this.state.pressedDropDown.name === "Facility"
                   ? <Row style={{alignItems: "left"}}>
                      <input type="text" style={{width: '90%', textAlign: "center", textAlign: "left", marginBottom: 20,marginRight: 20, marginLeft: 20, padding: 15}} value={item != null && item.address != null ? item.address : "No Address"} onChange={(e)=>{
                        this.onChangeExistingItemField(item, "address", e.target.value);

                        Geocode.fromAddress(e.target.value).then(
                                response => {
                                  const { lat, lng } = response.results[0].geometry.location;
                                  this.onChangeExistingItemField(this.state.guiltyObject, "latitude", lat);
                                  setTimeout(()=>{
                                    this.onChangeExistingItemField(this.state.guiltyObject, "longitude", lng);
                                  }, 50)

                                },
                                error => {
                                  console.error(error);
                                }
                              );

                        }}/>
                      </Row>
                   : null
                }
               <div style={{ height: '40vh', width: '100%' }}>
                      <GoogleMapReact
                            options={mapOptions}
                            bootstrapURLKeys={{ key: "AIzaSyDC_uFHUc5D6KXs5Ng1iVJsbJsQZvRpz6k" }}
                            defaultCenter={{lat: 10.6840, lng: 122.9563}}
                            center={center}
                            defaultZoom={18}
                            onClick={({ x, y, lat, lng, event })=>{
                              this.onChangeExistingItemField(this.state.guiltyObject, "latitude", lat);

                              setTimeout(()=>{
                                this.onChangeExistingItemField(this.state.guiltyObject, "longitude", lng);
                              },50)

                            }}>
                            <div
                              key={"Center Location"}
                              lat={center.lat}
                              lng={center.lng}>
                              <div style={{justifyContent: "center"}}>
                              <Row>
                                <Glyphicon className="pull-center" glyph="map-marker"
                                  style={{color: "red", fontSize: 30}}
                                  onClick={()=>{console.log("Clicked marker");}}/>
                              </Row>
                              </div>
                            </div>
                      </GoogleMapReact>
                    </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={()=>{this.setState({showMapOverlay: false})}}>Close</Button>
            </Modal.Footer>
           </Modal>);
  }

  //Messy, but unavoidable. Might as well concentrate all the mess here.
  processFieldType(field, itemParent) {
    var type = null;
    var data = null;

    if(field == "branch" && itemParent.name == "Auto Email") {
      type = "dropdown";
      data = {items: _.filter(this.state.dropDowns, (dropDown)=>{return dropDown.name == "Branch"})[0].items}
    } else if(field == "facility" && itemParent.name == "Auto Email") {
      type = "dropdown";
      data = {items: _.filter(this.state.dropDowns, (dropDown)=>{return dropDown.name == "Facility"})[0].items}
    } else if(field == "forceSend") {
      type = "checkbox";
    } else if(field == "autoEmail") {
      type = "textInput";
    } else if(field == "name" && itemParent.type == "custom") {
      type = "textInput";
    }

    return ({type: type, data: data});
  }

  //Seems to be
  uploadDropDownFile() {
    //API call here.
    //Brian: The arrow icons are not to move the categories up and down the order, they are for uploading and downloading
    //CSVs that pertain to the category. This was outlined in the User Stories via Confluence

  }

  downloadDropDownFile() {

  }

  //Put relevant on top
  filterItems(items, filterObject) {
    //Not really a Filter, but a sort. Sort all matching up top, THEN the non matching.
    var oldList = items.slice();
    var newList = [];//Matching first, then add remaining stuff

    items.map((item, i)=>{
      if(this.isValidTableItem(item)) {
        newList.push(item);
        oldList.splice(oldList.indexOf(item), 1);//Remove item from old list
      }
    });

    //Loop through remaining items and addd to new list
    oldList.map((item)=>{
      newList.push(item);
    });

    return newList.slice();
  }

  filterByActiveActual(items) {
    var oldList = items.slice();
    var newList = [];

    oldList.map((item)=>{
      if(this.isValidTableItem(item)) {
        newList.push(item);
      }
    })

    return newList.slice();

  }
  //This can only filter by string.
  isValidTableItem(item) {
    var tableFilter = this.state.tableFilter;
    var isValid = true;
    //Run through all of filter object's keys, to compare with existing objhects
    Object.keys(tableFilter).map((key)=>{
      //if(item[key] == null || (item[key].constructor === Array && item[key].indexOf(tableFilter[key]) < 0)) {
      if(item[key] == tableFilter[key] || (item[key].constructor === Array && item[key].indexOf(tableFilter[key]) >= 0)) {

      } else {
          isValid = false;
      }
    });
    return isValid;

  }

  setTableFilter(filter) {
    this.setState({
      tableFilter: filter
    })
  }

  filterByActive(active) {
    var newTableFilter = this.state.tableFilter;
    newTableFilter["isActive"] = active;
    this.setState({
      tableFilter: newTableFilter,
    })
  }

  getFormDataByType(dropDown, index){ //index used in then() block

    var type = dropDown.name.replace(/\s/g, '_');
    var newDropDown = JSON.parse(JSON.stringify(dropDown));
    var rawDropDown = JSON.parse(JSON.stringify(dropDown));

    const storedCredenials = this.state.storedCredenials;
    const loginResponse = storedCredenials.loginResponse;

    var params = {
      "license":loginResponse.data[0].User_License,
      "auth_username":loginResponse.data[0].User_ID,
      "token":loginResponse.token_data.token,
      "type":type
    };

      FormdataService.sharedInstance.getFormDataByType(params)
      .then((response)=>{
          var newDropDowns = JSON.parse(JSON.stringify(this.state.dropDowns));
          var rawDropDowns = JSON.parse(JSON.stringify(this.state.rawDropDowns));

          newDropDown.items = _.sortBy(this.repackItems(response.slice(), type), (itemListItem)=>{
             return parseInt(itemListItem.sortOrder)
           });
          rawDropDown.items = response.slice();

          newDropDowns.splice(index, 1, newDropDown);
          rawDropDowns.splice(index, 1, rawDropDown);

          var newState = {}
          this.setState({
            dropDowns : newDropDowns,
            rawDropDowns: rawDropDowns,
            pressedDropDown: this.state.pressedDropDown ? newDropDown : null,
          })

          this.props.updateData();
         //success
      }).catch((error)=>{
          console.log(error);
      });
  }

  //For adding stuff
  saveFormData(form_data) {

      const storedCredenials = this.state.storedCredenials;
      const loginResponse = storedCredenials.loginResponse;

      //BASIC SQL Dropdown
      //let form_data = { "type": "Client", "value":"Client", "is_active": 1, "sort_order": 1};

      let params = {};

      let type = form_data.type;
      let basic_sql_radio_values = ["call type", "incident type", "skill", "custom field 1", "custom field 2",  "custom field 3", "custom field 4",  "custom field 5"];
      if(basic_sql_radio_values.indexOf(type) >= 0){
        //if basic sql radio
        params = {
          "license":loginResponse.data[0] .User_License,
          "auth_username":loginResponse.data[0].User_ID,
          "token":loginResponse.token_data.token,
          "type":form_data.type.replace(/\s/g, '_'),
          "value": form_data.value,
          "is_active": form_data.is_active,
          "sort_order":form_data.sort_order
        };
      }
      else{
        if(type == "facility"){
          params = {
            "type": type,
            "license":loginResponse.data[0] .User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "facility_name":form_data.value, //@Terence it's either you use the form_data.value here or we should add .facility_name so it's the same in our columns
            "branch_id": this.props.getRecnoForName(form_data.branch, "Branch"), //@Terence, update here the the branch id,
            "client_id": this.props.getRecnoForName(form_data.client, "Client"), //@Ena, update here the the client id
            "is_active": form_data.is_active,
            "sort_order":form_data.sort_order,
            "latitude": form_data.latitude,
            "longitude": form_data.longitude,
            "address": form_data.address,
          };
        }
        else if(type == "event"){
          params = {
            "type": type,
            "license":loginResponse.data[0] .User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "event_name":form_data.value,
            "facility_id": this.props.getRecnoForName(form_data.facility, "Facility"),
            "is_reoccuring": form_data.isReoccurring,
            "frequency": form_data.frequency,
            "frequency_number": form_data.frequencyNumber,
            "event_date": form_data.event_date,
            "is_active": form_data.is_active,
            "sort_order":form_data.sort_order
          };
        } else if(type == "facility location") {
          params = {
            "type": type,
            "license":loginResponse.data[0] .User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "facility_id": form_data.facility,
            "location_name": form_data.value,
            "is_active": form_data.is_active,
            "sort_order":form_data.sort_order,
            "latitude": form_data.latitude,
            "longitude": form_data.longitude,
          };
        }
        else if(type == "auto email") {
          params = {
            "type": type,
            "license":loginResponse.data[0].User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "auto_email": form_data.autoEmail,
            "facility_id": this.props.getRecnoForName(form_data.facility, "Facility"),
            "branch_id": this.props.getRecnoForName(form_data.branch, "Branch"),
            "form_id": form_data.form,
            "force_send": form_data.forceSend,
            "is_active": form_data.is_active,
            "sort_order":form_data.sort_order
          }
        }
        else if(type == "branch") {
          params = {
            "license":loginResponse.data[0] .User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "type":form_data.type.replace(/\s/g, '_'),
            //"client_id": form_data.client,
            "is_active": form_data.is_active,
            "sort_order":form_data.sort_order,
            "branch_name": form_data.value,
          };
        }
        else if(type == "client") {
          params = {
            "license":loginResponse.data[0] .User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "type":form_data.type.replace(/\s/g, '_'),
            "is_active": form_data.is_active,
            "sort_order":form_data.sort_order,
            "client_name": form_data.value,
          };
        }
        //Add Event if block here
        //process here the params for other
      }

      console.log("params to saveForm: ", params);
      FormdataService.sharedInstance.saveFormData(params)
      .then((response)=>{
        if(type === "auto_email" ) {
          console.log(type, " response: ", response);
        }
          var typeIndex = null;
          var typeActual = this.state.pressedDropDown.name;
          this.state.dropDowns.map((dropDown, i)=>{
            if(dropDown.name == typeActual) {
              typeIndex = i;
            }
          });

          this.setState({
            newDropDown: {}
          });
          this.props.updateData();
          //this.getFormDataByType(this.state.dropDowns[typeIndex], typeIndex);
         //success
      }).catch((error)=>{
          console.log("saveFormData error: ", error);
      });
  }

  updateFormData(form_data) {
      const storedCredenials = this.state.storedCredenials;
      const loginResponse = storedCredenials.loginResponse;
      let basic_sql_radio_values = ["call type", "incident type", "skill", "custom field 1", "custom field 2",  "custom field 3", "custom field 4",  "custom field 5"];
      //let form_data = { "type": "Facility", "value":"Facility name here", "is_active": 1, "sort_order": 1, "recno_id":91222};

      var params = {

        sort_order: form_data.sortOrder,
        is_active: form_data.isActive ? 1 : 0,
        token: loginResponse.token_data.token,
        license: loginResponse.data[0] .User_License,
        auth_username: loginResponse.data[0].User_ID,
        type: form_data.type.toLowerCase().replace(' ', '_'),
      }
      console.log("form_data: ", form_data);
      if(basic_sql_radio_values.indexOf(form_data.type.toLowerCase()) >= 0) {
        params["value"] = form_data.name;
        params["recno_id"] = this.props.getRecnoForName(form_data.name, form_data.type);
      } else {
        if(form_data.type == "Facility") {
          params["facility_id"] = form_data.id;
          params["facility_name"] = this.props.getNameForRecno(form_data.id, "Facility");
          params["branch_id"] = this.props.getRecnoForName(form_data.branch, "Branch");
          params["client_id"] = this.props.getRecnoForName(form_data.client, "Client");
          params["address"] = form_data.address;
          params["latitude"] = form_data.latitude;
          params["longitude"] = form_data.longitude;
        } else if (form_data.type == "Facility Location"){
          params["facility_id"] = this.props.getRecnoForName(form_data.facility, "Facility");
          params["facility_location_id"] = form_data.id;
          params["location_name"] = form_data.name;
          params["latitude"] = form_data.latitude;
          params["longitude"] = form_data.longitude;
        } else if (form_data.type == "Event") {
          params["event_id"] = this.props.getRecnoForName(form_data.name, "Event");
          params["event_name"] = form_data.name;
          params["facility_id"] = this.props.getRecnoForName(form_data.facility, "Facility");
          params["event_date"] = form_data.date;
          params["is_reoccuring"] = form_data.isReoccurring;
          params["frequency"] = form_data.frequency;
          params["frequency_number"] = form_data.frequencyNumber;
        } else if(form_data.type == "Auto Email") {
          params['auto_email_id'] = form_data.id;
          params["auto_email"] = form_data.autoEmail;
          params["facility_id"] = this.props.getRecnoForName(form_data.facility, "Facility");
          params["form_id"] = this.getIDForFormName(form_data.name);
          params["branch_id"] = this.props.getRecnoForName(form_data.branch, "Branch");
          params["force_send"] = form_data.forceSend;

          if(params.sort_order == null) {
            params.sort_order = 0;
          }
        }
        else if(form_data.type == "Client") {
          params["id"] = form_data.id;
          params["client_name"] = form_data.name;
        }
        else if(form_data.type == "Branch") {
          params["id"] = form_data.id;
          params["branch_name"] = form_data.name;
        }
      }

      console.log("updateFormData params: ", params);
      FormdataService.sharedInstance.updateFormData(params)
      .then((response)=>{
          var typeIndex = 0;

          this.state.dropDowns.map((dropDown, i)=>{
            if(dropDown.name == form_data.type) {
              typeIndex = i;
            }
          });

          //this.getFormDataByType(this.state.dropDowns[typeIndex], typeIndex);
          if(this.props.updateData) {
              this.props.updateData();
          }

         //success
      }).catch((error)=>{
          console.log(error);
      });
  }

  deleteFormData(form_data, dropDown, dropDownItem) {
    const storedCredenials = this.state.storedCredenials;
    const loginResponse = storedCredenials.loginResponse;

    form_data["license"] = loginResponse.data[0] .User_License;
    form_data["auth_username"] = loginResponse.data[0].User_ID;
    form_data["token"] = loginResponse.token_data.token;
    form_data["id"] = form_data["recno_id"];
    delete form_data["recno_id"];
    FormdataService.sharedInstance.deleteFormData(form_data)
    .then((response)=>{
      console.log("response: ", response);

      var typeIndex = 0;

      this.state.dropDowns.map((dropDown, i)=>{
        if(dropDown.name == form_data.type.replace('_', ' ')) {
          typeIndex = i;
        }
      });
      ToastStore.warning("Deleted \"" + dropDownItem.name + "\" from \""+dropDown.name+"\"!", 5000);
      //this.getFormDataByType(this.state.dropDowns[typeIndex], typeIndex);
      this.props.updateData();

    })
    .catch((error)=>{
      console.log("error: ", error);
      ToastStore.error("Deletion failed: ", error)
    })
  }

  repackItems(items, type) {

    var newItems = items.length > 0 ? items.slice() : [];

    // Fail Fast Condition:
    if (items.length == 0){
      //console.log(type ,' is empty');
      return newItems;
    }

    if(type === "Auto_Email") {
      //console.log(type, " items: ", items );
    }

    switch(type) {
      case "Client":
        //{name: "Shiva Industries", sortOrder: 1, isActive: true}
        newItems = [];

        items.map((item)=>{

          newItems.push({
                          name: item.client_name,//item.Value.charAt(0).toUpperCase() + item.Value.slice(1),
                          sortOrder: parseInt(item.sort_order),
                          isActive: item.is_active == "1" ? true : false,
                          id: item.id
                        });
        });
      break;
      case "Branch":
        newItems = [];
        //{name: "Branch X", sortOrder: 1, isActive: true}
        items.map((item)=>{
          newItems.push({
                          //client: item.client_name ? item.client_name : "No Client",
                          name: item.branch_name,//item.Value.charAt(0).toUpperCase() + item.Value.slice(1),
                          sortOrder: parseInt(item.sort_order),
                          isActive: item.is_active == "1" ? true : false,
                          id: item.id,
                        });
        });
      break;
      case "Facility":
        newItems = [];

        items.map((item)=>{

          newItems.push({
                          name: item.facility_name,//item.facility_name.charAt(0).toUpperCase() + item.facility_name.slice(1),
                          branch: item.branch_name ? item.branch_name : "No Branch",
                          client: item.client_name ? item.client_name : "No Client",
                          sortOrder: parseInt(item.sort_order),
                          address: item.address,
                          longitude: item.longitude,
                          latitude: item.latitude,
                          isActive: item.is_active == "1" ? true : false,
                          id: item.facility_id,
                        });
        });
      break;
      case "Facility_Location":
        newItems = [];

        items.map((item)=>{

          newItems.push({
                          facility: item.facility_name ? item.facility_name : "No Facility",
                          name: item.location_name.charAt(0).toUpperCase() + item.location_name.slice(1),
                          sortOrder: parseInt(item.sort_order),
                          isActive: item.is_active == "1" ? true : false,
                          longitude: item.longitude,
                          latitude: item.latitude,
                          id: item.facility_location_id,
                        });
        });
      break;
      case "Event":
        newItems = [];

        items.map((item)=>{
          newItems.push({
                          name: item.event_name,//item.event_name.charAt(0).toUpperCase() + item.event_name.slice(1),
                          facility: item.facility_name ? item.facility_name : "No Facility",
                          date: item.event_date ? item.event_date : "No Date",
                          sortOrder: parseInt(item.sort_order),
                          isReoccurring: item.is_reoccuring,
                          frequency: item.frequency,
                          frequencyNumber: item.frequency_number,
                          isActive: item.is_active == "1" ? true : false,
                        });

        });
      break;
      case "Call_Type":
        //{name: "Shiva Industries", sortOrder: 1, isActive: true}
        newItems = [];

        items.map((item)=>{

          newItems.push({
                          name: item.Value,//item.Value.charAt(0).toUpperCase() + item.Value.slice(1),
                          sortOrder: parseInt(item.Sort_Order),
                          isActive: item.is_active == "1" ? true : false
                        });
        });
      break;
      case "Incident_Type":
        //{name: "Shiva Industries", sortOrder: 1, isActive: true}
        newItems = [];

        items.map((item)=>{

          newItems.push({
                          name: item.Value,//item.Value.charAt(0).toUpperCase() + item.Value.slice(1),
                          sortOrder: parseInt(item.Sort_Order),
                          isActive: item.is_active == "1" ? true : false
                        });
        });
      break;
      case "Skill":
        //{name: "Shiva Industries", sortOrder: 1, isActive: true}
        newItems = [];

        items.map((item)=>{

          newItems.push({
                          name: item.Value.charAt(0).toUpperCase() + item.Value.slice(1),
                          sortOrder: parseInt(item.Sort_Order),
                          isActive: item.is_active == "1" ? true : false
                        });
        });
      break;
      case "Auto_Email":
        newItems = [];
        items.map((item)=>{
          newItems.push({
                          name: item.form_name ? item.form_name : "No Email",
                          branch: item.branch_name ? item.branch_name : "No Branch",
                          facility: item.facility_name ? item.facility_name : "No Facility",
                          autoEmail: item.auto_email ? item.auto_email : "No Email",
                          forceSend: item.force_send,
                          id: item.auto_email_id,
                          isActive: item.is_active == "1" ? true : false,
                        });
        });

        //{name: "Daily Activity Report", branch: "Branch X", facility: "Brian's Bar", autoEmail: "brodude@archontech.com", forceSend: false}
      break;
      default://Assume Custom Field
        newItems = [];

        items.map((item)=>{

          newItems.push({
                          name: item.Value.charAt(0).toUpperCase() + item.Value.slice(1),
                          sortOrder: parseInt(item.Sort_Order),
                          isActive: item.is_active == "1" ? true : false
                        });
        });
      break;
    }

      return newItems;
  }

  //For Dependencies. i.e. Facility Location MUST have a Facility
  isValidItemToAdd(item, type) {
    var displayType = type;
    if(type.indexOf("Custom Field")>= 0) {
      type = "custom";
    }
    type = this.camelize(type);

    var isValid = true;
    //Required fields for added items
    var templates = {client: ["name"],
                      branch: ["name"],
                      facility: ["name", "branch", "address", "longitude", "latitude"],
                      facilityLocation: ["facility", "name"],
                      event: ["name", "facility", "date"],
                      callType: ["name"],
                      incidentType: ["name"],
                      skill: ["name"],
                      autoEmail: ["name", "branch", "autoEmail"],
                      custom: ["name"]};
    var invalidFields = "";

    templates[type].map((field, i)=>{
      if(item[field] == null || item[field] == "") {
        isValid = false;

        if(invalidFields == "") {
          invalidFields += field.charAt(0).toUpperCase() + field.slice(1)
        } else {
          invalidFields += ", " + field.charAt(0).toUpperCase() + field.slice(1)
        }

      }
    })

    if(!isValid) {
      ToastStore.warning(displayType + " has missing required fields: " + invalidFields, 5000);
    }

    return isValid;
  }

  camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  }

  getIDForFormName(name) {
    var id = null;
    var form = _.find(this.props.forms, (form)=>{
      return form.form_name == name
    });

    return form ? form.recno : null;

  }

  updateData() {
    this.state.dropDowns.map((dropDown, i)=>{
        this.getFormDataByType(dropDown, i);
    })
  }
}


export default FormData;
